import React, { useEffect, useState } from "react";
import { Table, Input, Col, Row } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { getDocs, collection, doc, query, where } from "firebase/firestore";

import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";

import { OwnersRightBar } from "./ownersData";
import { NavLink, useNavigate } from "react-router-dom";
import { auth, db } from "../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";

function Owners() {
  const [filterData, setFilterData] = useState([]);
  const [sortedInfo, setSortedInfo] = useState({});
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [searchState, setSearchState] = useState({
    query: "",
    list: [],
  });

  const navigate = useNavigate();

  const handleSearchFilter = (e) => {
    const results = filterData.filter((post) => {
      if (e.target.value === "") return post;

      const matchesFirstName =
        post.ownerInfo && post.ownerInfo.firstName
          ? post.ownerInfo.firstName
              .toLowerCase()
              .includes(e.target.value.toLowerCase())
          : false;

      // Check if emails array exists and the first email's email property exists before trying to lowercase and match
      const matchesEmail =
        post.contact &&
        post.contact.emails &&
        post.contact.emails[0] &&
        post.contact.emails[0].email
          ? post.contact.emails[0].email
              .toLowerCase()
              .includes(e.target.value.toLowerCase())
          : false;

      return matchesFirstName || matchesEmail;
    });

    setSearchState({
      query: e.target.value,
      list: results,
    });
  };

  const handleChange = (sorter) => {
    setSortedInfo(sorter);
  };

  const tableHeader = [
    {
      title: "Name",
      dataIndex: "firstName",
      // key: "firstName",
      // sorter: (a, b) =>
      //   a.ownerInfo.firstName.length - b.ownerInfo.firstName.length,
      // sortOrder: sortedInfo.columnKey === "firstName" ? sortedInfo.order : null,
      // ellipsis: true,
      render: (_, document) => {
        return (
          <span className="onclick-text">
            <NavLink>
              {document?.ownerInfo?.firstName} {document?.ownerInfo?.lastName}
            </NavLink>
          </span>
        );
      },
    },
    {
      title: "Company",
      dataIndex: "companyName",
      // key: "companyName",
      // sorter: (a, b) =>
      //   a.ownerInfo.companyName.length - b.ownerInfo.companyName.length,
      // sortOrder:
      //   sortedInfo.columnKey === "companyName" ? sortedInfo.order : null,
      render: (_, document) => <span>{document?.ownerInfo?.companyName}</span>,
    },
    {
      title: "Phone",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      // sorter: (a, b) =>
      //   a.ownerContacts.phoneNumber0.phoneNumber.length -
      //   b.ownerContacts.phoneNumber0.phoneNumber.length,
      // sortOrder: sortedInfo.columnKey === "phone" ? sortedInfo.order : null,
      render: (_, record) => (
        <span>
          {record?.contact?.phoneNumbers?.length > 0
            ? record?.contact?.phoneNumbers[0]?.phoneNumber
            : "--"}
        </span>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      // key: "email",
      // sorter: (a, b) => a.ownerEmail.length - b.ownerEmail.length,
      // sortOrder: sortedInfo.columnKey === "email" ? sortedInfo.order : null,
      render: (_, record) => (
        <span>
          {record?.contact?.emails?.length > 0 ? record?.contact?.emails[0]?.email : "--"}
        </span>
      ),
    },
  ];

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
          setIsCompanyNameFetched(true);
        })

        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const getOwners = async () => {
    setIsLoading(true); // stop loading

    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const ownerRef = collection(companyDocRef, "owners");
      const data = await getDocs(ownerRef);
      const ownersData = data.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setSearchState((prevState) => ({
        ...prevState,
        list: ownersData,
      }));
      setFilterData(ownersData);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false); // stop loading
    }
  };
  useEffect(() => {
    if (!isCompanyNameFetched) return;

    getOwners();
  }, [companyName, isCompanyNameFetched]);

  console.log("filterData", filterData);
  return (
    <>
      <div>
        <PageHeading heading="Owners" />
        <Row>
          <Col span={24}>
            <Input
              placeholder="Search by name or email"
              suffix={
                <SearchOutlined
                  style={{
                    color: "rgba(0,0,0,.45)",
                  }}
                />
              }
              value={searchState.query}
              onChange={handleSearchFilter}
            />
          </Col>
        </Row>
        <br />
        <Table
          columns={tableHeader}
          dataSource={searchState?.list}
          onChange={handleChange}
          loading={isLoading} // Set loading prop
          rowKey={(obj) => obj.id}
          onRow={(record) => {
            return {
              onClick: () =>
                navigate(`/people/owners/owners-details/${record.id}`),
            };
          }}
        />
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={OwnersRightBar} />
      </div>
    </>
  );
}

export default Owners;
